import React, { Component } from 'react'
import _find from "lodash/find";

import {
    Icon,
    Spinner,
    GridCell,
    Grid,
    css,
    Section,
    Select,
    TextInput,
} from "@bdfx/mergado-ui-kit"

import trans from "trans";
import { TEMPLATE_GALLERY_GROUPS, TemplateGalleryType } from 'template-edit/components/template-gallery';
import PreviewTemplateSVG from 'template-edit/containers/preview-template-svg';
import { AlternativeImage, RandomProduct } from 'shape-edit/types';
import { isJson } from 'app/helpers/other';

export type PromoTemplate = {
    priority: number
    trans_cz: string
    trans_en: string
    templates: string
    is_remove_background: string
    is_random_color: string
}

interface Props {
    templateGallery: TemplateGalleryType[]
    i: number
    j: number
    group: string
    close: Function
    selectTemplate: Function
}

interface State {
    selectedTemplateId: number
    filterGroup: string
    previewImageUrl: string
    previewImageUrlBgRemoved: string
}

class SelectPromoTemplateModalWrapper extends Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = {
            selectedTemplateId: null,
            filterGroup: props.group,
            /* previewImageUrl: 'https://audit-obrazku.cz/a/ai/demo/4bf07d178bcaf52286073b322deebc52ef15c830748ff2975f25035c27540fdc_orig.jpeg', */
            previewImageUrl: 'https://img.freepik.com/free-photo/portrait-dog-isolated-white-created-using-generative-ai_60438-2499.jpg?size=626&ext=jpg',
            previewImageUrlBgRemoved: 'https://audit-obrazku.cz/a/ai/demo/4bf07d178bcaf52286073b322deebc52ef15c830748ff2975f25035c27540fdc_bgremoved.png',
        }
    }

    render() {
        const { previewImageUrl, previewImageUrlBgRemoved, filterGroup } = this.state
        const { templateGallery, i, j } = this.props

        const alternativeImage: AlternativeImage = {
            url: 'https://www.feed-image-editor.com/sites/all/themes/fie/logo.svg',
            w: 365,
            h: 60
        }
        const randomProduct: RandomProduct = {
            id: null,
            serialized_data: [],
            isAlt: false,
            image_id: null,
            image_link: previewImageUrl,
            alternative_images: [alternativeImage],
            origWidth: 200,
            origHeight: 200,
            width: 200,
            height: 200,
            image_hash: null,
            isLoading: false,
            isLoaded: true,
            isError: null,
        }

        const randomProductBgRemoved: RandomProduct = {
            id: null,
            serialized_data: [],
            image_id: null,
            isAlt: false,
            image_link: previewImageUrlBgRemoved,
            alternative_images: [alternativeImage],
            origWidth: 200,
            origHeight: 200,
            width: 200,
            height: 200,
            image_hash: null,
            isLoading: false,
            isLoaded: true,
            isError: null,
        }

        const templateGalleryOptions = TEMPLATE_GALLERY_GROUPS.map(name => {
            return { value: name, label: trans(`group_${name}`) }
        })

        return (
            <StyledSection
                prefix={<Select
                    placeholder={trans('group_all_templates')}
                    value={filterGroup}
                    options={[
                        { value: null, label: trans(`group_all_templates`) },
                        ...templateGalleryOptions,
                    ]}
                    onChange={(value) => this.setState({ filterGroup: value })}
                    multiple={false}
                    closeOnChange={true}
                />}
                header={<TextInput value={previewImageUrl} onChange={(value) => this.setState({ previewImageUrl: value })} />}
                suffix={<TextInput value={previewImageUrlBgRemoved} onChange={(value) => this.setState({ previewImageUrlBgRemoved: value })} />}
            >
                <Grid className={'select-grid'} cols="repeat(auto-fit, minmax(200px, 1fr))" gap={"5px"} >
                    {templateGallery &&
                        templateGallery
                            .filter(o => (!filterGroup || !o.groups || o.groups.includes(filterGroup)))
                            .map((o: TemplateGalleryType, idx: number) => {
                                const parsedJson = isJson(o.serialized_template) ? JSON.parse(o.serialized_template) : null
                                const isBgRemove = !!parsedJson?.is_remove_background
                                const isRandomColors = !!parsedJson?.background_type?.startsWith('dominant')

                                return <GridCell
                                    key={idx}
                                    className={'clickable'}
                                    title={`${o.id}`}
                                    onClick={() => {
                                        this.props.selectTemplate(o.id, i, j, isBgRemove, isRandomColors)
                                        this.props.close()
                                    }}>
                                    <PreviewTemplateSVG
                                        templateGallery={o}
                                        randomProduct={isBgRemove ? randomProductBgRemoved : randomProduct}
                                        isAlt={false}
                                    />
                                </GridCell>
                        })}
                </Grid>
            </StyledSection>
        )
    }
}

const StyledSection = css(Section)({
    ' .m-content': {
        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto',
    },
    ' .muk-grid.m-header': {
        gridTemplateColumns: '200px 1fr 1fr',
    },
    ' .select-grid': {
        overflow: 'auto',
    },
    ' .muk-form-group': {
        marginBottom: '0px',
    }
})


export default SelectPromoTemplateModalWrapper